<section class="cue-section cue-section--warnings">
	<span class="cue-step-label">3. Qué hay que revisar</span>
	<h4>Avisos y correcciones</h4>

	@if (hasWarnings) {
		<div class="cue-warning-list">
			@for (warning of warnings; track warning.id) {
				<article class="cue-warning-item">
					<div class="cue-warning-item__header">
						<strong>{{ warning.title }}</strong>
						<p-tag value="Revisar" [severity]="warning.severity" [rounded]="true"></p-tag>
					</div>

					<p><strong>Qué pasa:</strong> {{ warning.message }}</p>
					<p><strong>Dónde corregirlo:</strong> {{ warning.location }}</p>
					<p><strong>Qué hacer:</strong> {{ warning.action }}</p>

					@if (warning.technicalDetail) {
						<details class="cue-inline-technical-details">
							<summary>Ver detalle técnico</summary>
							<pre>{{ warning.technicalDetail }}</pre>
						</details>
					}
				</article>
			}
		</div>
	} @else {
		<div class="cue-ok-review">
			<i class="pi pi-check-circle" aria-hidden="true"></i>
			<p>{{ emptyMessage }}</p>
		</div>
	}
</section>
